import { Link } from "react-router-dom";
import { ArrowUpRight, Check, PhoneCall } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import CtaBand from "@/components/home/CtaBand";
import { AUDIENCES } from "@/data/content";

export default function WhoWeHelp() {
  return (
    <div data-testid="who-we-help-page">
      <section className="pt-36 sm:pt-44 pb-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <Eyebrow>Who we help</Eyebrow>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-ink leading-[1.05] max-w-3xl">
              Built for people who <span className="font-editorial italic font-medium text-gold-600">build things.</span>
            </h1>
            <p className="mt-8 text-base sm:text-lg text-ink/60 max-w-2xl leading-relaxed">
              Developers, makers, traders, professionals and investors — if your income doesn't fit a bank's
              checkbox, that's exactly where decades of commercial experience pay off.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 sm:pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 gap-6">
            {AUDIENCES.map((a, i) => (
              <Reveal key={a.slug} delay={0.05 * (i % 2)}>
                <div
                  data-testid={`audience-card-${a.slug}`}
                  className="group h-full rounded-3xl bg-white border border-ink/8 p-8 sm:p-10 transition-all duration-500 hover:-translate-y-2 hover:border-gold/60 hover:shadow-lift flex flex-col"
                >
                  <span className="w-14 h-14 rounded-2xl bg-brand-light flex items-center justify-center mb-7 transition-colors duration-300 group-hover:bg-gold-50">
                    <a.icon size={24} className="text-brand transition-colors duration-300 group-hover:text-gold-600" strokeWidth={1.6} />
                  </span>
                  <h2 className="font-display text-2xl font-bold text-ink mb-3">{a.title}</h2>
                  <p className="text-ink/55 leading-relaxed mb-6">{a.hook}</p>
                  <ul className="space-y-2.5 mb-8 flex-1">
                    {a.points.map((p) => (
                      <li key={p} className="flex items-start gap-3 text-sm text-ink/70">
                        <Check size={15} className="text-brand mt-0.5 shrink-0" strokeWidth={2.5} />
                        {p}
                      </li>
                    ))}
                  </ul>
                  <div className="flex flex-wrap gap-3">
                    <Link
                      to={`/callback?audience=${a.slug}&utm_source=who-we-help`}
                      data-testid={`audience-callback-${a.slug}`}
                      className="inline-flex items-center gap-2 rounded-full bg-obsidian text-gold px-6 py-3 text-sm font-semibold transition-all duration-300 hover:bg-gold hover:text-obsidian"
                    >
                      <PhoneCall size={14} /> Request a callback
                    </Link>
                    <Link
                      to={`/book`}
                      data-testid={`audience-book-${a.slug}`}
                      className="group/l inline-flex items-center gap-1.5 rounded-full border border-ink/15 px-6 py-3 text-sm font-semibold text-ink transition-all duration-300 hover:border-gold hover:text-gold-700"
                    >
                      Book a meeting
                      <ArrowUpRight size={14} className="transition-transform duration-300 group-hover/l:translate-x-0.5 group-hover/l:-translate-y-0.5" />
                    </Link>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
